import React, { useState } from "react"; //useEffect
import {
  Form,
  Input,
  //InputNumber,
  Select,
  Button,
  Row,
  Col,
  notification,
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  //CarOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  //IdcardOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { addPersonApi } from "../../../../api/person";
import { getAccessToken } from "../../../../api/auth";
import {
  emailValidation,
  minLengthValidation,
  numberValidation,
} from "../../../../utils/formValidation";

import "./AddPersonForm.scss";

export default function AddPersonForm(props) {
  const { setIsVisibleModal, setReloadPersons } = props;
  //const [listDocumentTypesActive, setListDocumentTypesActive] = useState([]);

  const [inputs, setInputs] = useState({
    type: "physical",
    name: "",
    lastname: "",
    address: "",
    phone1: "",
    documentType: "",
    documentNumber: "",
    birthDate: "",
    email: "",
    observation: "",
  });

  const [formValid, setFormValid] = useState({
    email: false,
    documentNumber: false,
    phone1: false,
  });

  const inputValidation = (e) => {
    const { type, name } = e.target;

    setInputs({
      ...inputs,
      [name]: e.target.value,
    });

    if (name === "email") {
      setFormValid({
        ...formValid,
        [name]: emailValidation(e.target),
      });
    }
    if (name === "documentNumber") {
      let result = false;
      if (numberValidation(e.target) && minLengthValidation(e.target, 7)) {
        result = true;
      }
      setFormValid({
        ...formValid,
        //[name]: numberValidation(e.target)
        [name]: result,
      });
    }
    if (name === "phone1" || name === "phone2") {
      setFormValid({
        ...formValid,
        [name]: numberValidation(e.target),
      });
    }
  };

  const isFormValid = (e) => {
    let errorExists = false;
    if(inputs.type === "physical"){
      if (
        !inputs.name ||
        !inputs.address ||
        !inputs.documentType ||
        !inputs.documentNumber ||
        !inputs.email
      ) {
        //inputs.perception_bsas ===null || inputs.perception_caba ===null
        notification["error"]({
          message:
            "Obligatorios: Nombre, Apellido, Domicilio, Tipo de documento, Nro de documento y correo",
        });
        errorExists = true;
      }
    }
    if(inputs.type === "legal"){
      if (
        !inputs.name ||
        !inputs.cuit_cuil ||
        !inputs.address ||
        !inputs.email
      ) {
        //inputs.perception_bsas ===null || inputs.perception_caba ===null
        notification["error"]({
          message:
            "Obligatorios: Nombre, CUIL/CUIT, Domicilio y correo",
        });
        errorExists = true;
      }
    }
    if (!formValid.email && inputs.email !== "") {
      notification["error"]({
        message: "El correo es inválido",
      });
      errorExists = true;
    }
    if (!formValid.phone1 && inputs.phone1 !== "") {
      notification["error"]({
        message: "Ingreso de teléfono inválido",
      });
      errorExists = true;
    }
    if (!formValid.documentNumber && inputs.documentNumber !== "") {
      notification["error"]({
        message: "El número de documento es inválido",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addPerson = async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      const accessToken = getAccessToken();

      await addPersonApi(accessToken, inputs)
        .then((response) => {
          if (
            response === "ERR_CONNECTION_REFUSED" ||
            response === "Failed to fetch" ||
            response === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
          } else if (response.code !== 200) {
            notification["error"]({
              message: response.message,
            });
          } else {
            notification["success"]({
              message: "Persona creada",
            });
            setIsVisibleModal(false);
          }
          setReloadPersons(true);
        })
        .catch((err) => {
          notification["error"]({
            message: err,
          });
        });
    }
  };

  return (
    <div className="add-person-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        inputValidation={inputValidation}
        addPerson={addPerson}
      />
    </div>
  );
}

function AddForm(props) {
  const {
    inputs,
    setInputs,
    inputValidation,
    addPerson,
  } = props;
  const { Option } = Select;

  return (
    <Form className="form-add" onSubmit={addPerson}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Tipo
          </label>
          <Form.Item>
            <Select
              placeholder="Tipo"
              name="type"
              defaultValue={"physical"}
              value={inputs.type}
              onChange={(e) => setInputs({ ...inputs, type: e })}
            >
              <Option value="physical">Física</Option>
              <Option value="legal">Jurídica</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Nombre
          </label>
          <Form.Item>
            <Input
              prefix={<UserOutlined />}
              placeholder="Nombre"
              name="name"
              value={inputs.name}
              onChange={(e) => setInputs({ ...inputs, name: e.target.value })}
            />
          </Form.Item>
        </Col>
        {inputs.type ==="physical" ?
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Apellido
          </label>
          <Form.Item>
            <Input
              prefix={<UserOutlined />}
              placeholder="Apellido"
              value={inputs.lastname}
              onChange={(e) =>
                setInputs({ ...inputs, lastname: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        : null }
        {inputs.type==="legal" ?
        <Col span={8}>
          <label className="control-label">
          <span className="control-required">*</span>CUIL/CUIT</label>
          <Form.Item>
            <Input
              //prefix={<EnvironmentOutlined />}
              placeholder="CUIL/CUIT"
              name="cuit_cuil"
              value={inputs.cuit_cuil}
              onChange={(e) =>
                setInputs({ ...inputs, cuit_cuil: e.target.value })
              }
            />
          </Form.Item>
        </Col> : null}
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      {inputs.type==="physical" ?
        <Col span={8}>
          <label className="control-label">CUIL/CUIT</label>
          <Form.Item>
            <Input
              //prefix={<EnvironmentOutlined />}
              placeholder="CUIL/CUIT"
              name="cuit_cuil"
              value={inputs.cuit_cuil}
              onChange={(e) =>
                setInputs({ ...inputs, cuit_cuil: e.target.value })
              }
            />
          </Form.Item>
        </Col> : null}

        {inputs.type ==="physical" ?
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span>Nº de documento
          </label>
          <Form.Item>
            <Input
              prefix={<UserOutlined />}
              placeholder="Nº de documento"
              name="documentNumber"
              value={inputs.documentNumber}
              maxLength={11}
              //onChange={(e) => setInputs({ ...inputs, cuit: e.target.value })}
              onChange={inputValidation}
            />
          </Form.Item>
        </Col>
        : null}
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Correo Electrónico
          </label>
          <Form.Item>
            <Input
              prefix={<MailOutlined />}
              placeholder="Correo Electrónico"
              name="email"
              type="email"
              value={inputs.email}
              onChange={inputValidation}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">
          <span className="control-required">*</span>Domicilio</label>
          <Form.Item>
            <Input
              prefix={<EnvironmentOutlined />}
              placeholder="Domicilio"
              name="address"
              value={inputs.address}
              onChange={(e) =>
                setInputs({ ...inputs, address: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">
           Fecha Nacimiento
          </label>
          <Form.Item>
            <Input
              type="date"
              placeholder="fecha nacimiento"
              value={inputs.birthDate}
              onChange={(e) =>
                setInputs({ ...inputs, birthDate: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={8}>
          <label className="control-label">Teléfono 1</label>
          <Form.Item>
            <Input
              prefix={<PhoneOutlined />}
              placeholder="Teléfono"
              name="phone1"
              //onChange={(e) => setInputs({ ...inputs, phone: e.target.value })}
              onChange={inputValidation}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">Teléfono 2</label>
          <Form.Item>
            <Input
              prefix={<PhoneOutlined />}
              placeholder="Teléfono 2"
              name="phone2"
              //onChange={(e) => setInputs({ ...inputs, phone: e.target.value })}
              onChange={inputValidation}
            />
          </Form.Item>
        </Col>
        {inputs.type==="legal" ?
        <Col span={8}>
          <label className="control-label">
            Razon Social
          </label>
          <Form.Item>
            <Input
              prefix={<UserOutlined />}
              placeholder="Razon Social"
              name="businessName"
              value={inputs.business_name}
              onChange={(e) =>
                setInputs({ ...inputs, businessName: e.target.value })
              }
            />
          </Form.Item>
        </Col> 
        : null}
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <label className="control-label">Observaciones</label>
          <Form.Item>
            <TextArea
              placeholder="Observaciones"
              name="observation"
              value={inputs.observation}
              onChange={(e) =>
                setInputs({ ...inputs, observation: e.target.value })
              }
              size="middle"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addPerson}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
